import { render, staticRenderFns } from "./mock-phone.vue?vue&type=template&id=fdb51d7c&scoped=true&"
import script from "./mock-phone.vue?vue&type=script&lang=js&"
export * from "./mock-phone.vue?vue&type=script&lang=js&"
import style0 from "./mock-phone.vue?vue&type=style&index=0&id=fdb51d7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb51d7c",
  null
  
)

export default component.exports